import { render, staticRenderFns } from "./LogoPreview.vue?vue&type=template&id=166a0fe6"
import script from "./LogoPreview.vue?vue&type=script&lang=js"
export * from "./LogoPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports